(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cherify-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  class CherifyPdpReviews extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.activeType = 'item';
      this.activeRating = 'all';
      this.currentPage = 1;
      this.pageSize = Number(this.dataset.pageSize) || 4;
      this.reviewItems = Array.from(this.querySelectorAll('[data-review-item]'));
      this.resizeHandler = () => this.updateTabIndicator();

      this.bindEvents();
      this.watchForRealReviews();
      this.render();
      requestAnimationFrame(() => this.updateTabIndicator());
      window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
      this.realReviewObserver?.disconnect();
      clearTimeout(this.realReviewTimer);
    }

    bindEvents() {
      this.querySelectorAll('[data-review-tab]').forEach((button) => {
        button.addEventListener('click', () => {
          this.activeType = button.dataset.reviewTab;
          this.activeRating = 'all';
          this.currentPage = 1;
          this.render();
        });
      });

      this.querySelectorAll('[data-filter-rating]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          this.activeRating = button.dataset.filterRating;
          this.currentPage = 1;
          this.render();
        });
      });

      this.querySelectorAll('[data-summary-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          this.activeRating = button.dataset.summaryFilter;
          this.currentPage = 1;
          this.render();
          this.querySelector('.cherify-pdp-reviews__top-row')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      this.querySelector('[data-write-review]')?.addEventListener('click', () => this.toggleForm(true));
      this.querySelectorAll('[data-form-close]').forEach((button) => {
        button.addEventListener('click', () => this.toggleForm(false));
      });

      this.querySelectorAll('[data-rating-value]').forEach((button) => {
        button.addEventListener('click', () => this.setFormRating(Number(button.dataset.ratingValue)));
      });

      this.querySelector('[data-review-body]')?.addEventListener('input', (event) => {
        const counter = this.querySelector('[data-character-count]');
        if (counter) counter.textContent = String(event.target.value.length);
      });

      this.querySelector('[data-review-files]')?.addEventListener('change', (event) => {
        const fileName = this.querySelector('[data-file-name]');
        if (!fileName) return;
        const names = Array.from(event.target.files ?? []).map((file) => file.name);
        fileName.textContent = names.join(', ');
      });

      this.querySelector('[data-review-form]')?.addEventListener('submit', (event) => this.submitReview(event));
      this.querySelector('[data-review-page="previous"]')?.addEventListener('click', () => this.changePage(-1));
      this.querySelector('[data-review-page="next"]')?.addEventListener('click', () => this.changePage(1));
    }

    watchForRealReviews() {
      const hasRealReviews = () => document.querySelector('.jdgm-widget, .jdgm-rev-widg, [data-judge-me], .spr-container, [data-okendo-reviews]');
      const hideFallback = () => {
        if (!hasRealReviews()) return false;
        this.closest('[data-cherify-review-fallback-section]')?.setAttribute('hidden', '');
        document.querySelectorAll('[data-cherify-review-fallback]').forEach((rating) => rating.setAttribute('hidden', ''));
        this.realReviewObserver?.disconnect();
        return true;
      };

      if (hideFallback()) return;
      this.realReviewObserver = new MutationObserver(hideFallback);
      this.realReviewObserver.observe(document.body, { childList: true, subtree: true });
      this.realReviewTimer = setTimeout(() => this.realReviewObserver?.disconnect(), 5000);
    }

    getCounts() {
      const raw = this.activeType === 'store' ? this.dataset.storeCounts : this.dataset.itemCounts;
      return String(raw || '0,0,0,0,0').split(',').map((value) => Number(value) || 0);
    }

    render() {
      this.querySelectorAll('[data-review-tab]').forEach((button) => {
        const active = button.dataset.reviewTab === this.activeType;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });

      const counts = this.getCounts();
      const total = counts.reduce((sum, count) => sum + count, 0);
      const average = this.activeType === 'store' ? this.dataset.storeAverage : this.dataset.itemAverage;
      const averageNode = this.querySelector('[data-average]');
      const totalNode = this.querySelector('[data-review-total]');
      const headingNode = this.querySelector('[data-summary-heading]');

      if (averageNode) averageNode.textContent = average;
      if (totalNode) totalNode.textContent = String(total);
      if (headingNode) {
        headingNode.textContent = this.activeType === 'store' ? this.dataset.storeHeading : this.dataset.itemHeading;
      }

      this.querySelectorAll('[data-summary-star]').forEach((row) => {
        const rating = Number(row.dataset.summaryStar);
        const count = counts[5 - rating] || 0;
        const percent = total > 0 ? Math.round((count / total) * 100) : 0;
        const bar = row.querySelector('[data-summary-bar]');
        const label = row.querySelector('[data-summary-percent]');
        if (bar) bar.style.width = `${percent}%`;
        if (label) label.textContent = `${percent}%`;
      });

      this.querySelectorAll('[data-filter-rating]').forEach((button) => {
        const rating = button.dataset.filterRating;
        const count = rating === 'all' ? total : counts[5 - Number(rating)] || 0;
        const countNode = button.querySelector('[data-filter-count]');
        if (countNode) countNode.textContent = `(${count})`;
        button.disabled = rating !== 'all' && count === 0;
        button.classList.toggle('is-active', rating === this.activeRating);
      });

      const filtered = this.reviewItems.filter((item) => {
        const matchesType = item.dataset.reviewType === this.activeType;
        const matchesRating = this.activeRating === 'all' || item.dataset.reviewRating === this.activeRating;
        return matchesType && matchesRating;
      });

      const pageCount = Math.max(1, Math.ceil(filtered.length / this.pageSize));
      this.currentPage = Math.min(this.currentPage, pageCount);
      const start = (this.currentPage - 1) * this.pageSize;
      const visible = new Set(filtered.slice(start, start + this.pageSize));
      this.reviewItems.forEach((item) => {
        item.hidden = !visible.has(item);
      });

      const empty = this.querySelector('[data-review-empty]');
      if (empty) empty.hidden = filtered.length > 0;
      this.renderPagination(pageCount, filtered.length > 0);
      requestAnimationFrame(() => this.updateTabIndicator());
    }

    renderPagination(pageCount, hasReviews) {
      const pagination = this.querySelector('[data-pagination]');
      const numbers = this.querySelector('[data-page-numbers]');
      if (!pagination || !numbers) return;

      pagination.hidden = !hasReviews || pageCount <= 1;
      numbers.replaceChildren();

      for (let page = 1; page <= pageCount; page += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(page);
        button.classList.toggle('is-active', page === this.currentPage);
        button.setAttribute('aria-label', `Review page ${page}`);
        button.addEventListener('click', () => {
          this.currentPage = page;
          this.render();
        });
        numbers.append(button);
      }

      const previous = this.querySelector('[data-review-page="previous"]');
      const next = this.querySelector('[data-review-page="next"]');
      if (previous) previous.disabled = this.currentPage === 1;
      if (next) next.disabled = this.currentPage === pageCount;
    }

    changePage(direction) {
      this.currentPage += direction;
      this.render();
      this.querySelector('.cherify-pdp-reviews__top-row')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    updateTabIndicator() {
      const active = this.querySelector('[data-review-tab].is-active');
      const indicator = this.querySelector('[data-tab-indicator]');
      if (!active || !indicator) return;
      indicator.style.left = `${active.offsetLeft}px`;
      indicator.style.width = `${active.offsetWidth}px`;
    }

    toggleForm(open) {
      const form = this.querySelector('[data-review-form]');
      if (!form) return;
      form.hidden = !open;
      if (open) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        form.querySelector('textarea')?.focus({ preventScroll: true });
      }
    }

    setFormRating(rating) {
      const input = this.querySelector('[data-rating-input]');
      if (input) input.value = String(rating);
      this.querySelectorAll('[data-rating-value]').forEach((button) => {
        button.classList.toggle('is-active', Number(button.dataset.ratingValue) <= rating);
      });
    }

    submitReview(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const formData = new FormData(form);
      const rating = Number(formData.get('rating')) || 5;
      const author = String(formData.get('reviewer_name') || '').trim();
      const body = String(formData.get('review_body') || '').trim();
      if (!author || !body) return;

      const item = document.createElement('li');
      item.className = 'cherify-pdp-reviews__item';
      item.dataset.reviewType = this.activeType;
      item.dataset.reviewRating = String(rating);
      item.dataset.reviewItem = '';

      const header = document.createElement('div');
      header.className = 'cherify-pdp-reviews__item-header';
      const stars = document.createElement('div');
      stars.className = 'cherify-pdp-reviews__stars';
      stars.textContent = `${'★'.repeat(rating)}${'☆'.repeat(5 - rating)}`;
      const date = document.createElement('time');
      date.textContent = new Date().toLocaleDateString('en-US');
      const authorName = document.createElement('strong');
      authorName.className = 'cherify-pdp-reviews__author';
      authorName.textContent = author;
      header.append(stars, authorName);

      const itemMeta = document.createElement('div');
      itemMeta.className = 'cherify-pdp-reviews__item-meta';
      const verified = document.createElement('span');
      verified.className = 'cherify-pdp-reviews__verified';
      verified.textContent = this.dataset.verifiedLabel;
      itemMeta.append(verified, date);

      const reviewText = document.createElement('p');
      reviewText.className = 'cherify-pdp-reviews__item-text';
      reviewText.textContent = body;
      item.append(header, itemMeta, reviewText);

      const list = this.querySelector('[data-review-list]');
      list?.prepend(item);
      this.reviewItems.unshift(item);
      this.activeRating = 'all';
      this.currentPage = 1;
      form.reset();
      this.setFormRating(5);
      const characterCount = this.querySelector('[data-character-count]');
      const fileName = this.querySelector('[data-file-name]');
      const success = this.querySelector('[data-form-success]');
      if (characterCount) characterCount.textContent = '0';
      if (fileName) fileName.textContent = '';
      if (success) {
        success.textContent = this.dataset.formSuccess;
        success.hidden = false;
      }
      this.render();
    }
  }

  if (!customElements.get('cherify-pdp-reviews')) {
    customElements.define('cherify-pdp-reviews', CherifyPdpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cherify-product-reviews"] && !Shopify.designMode) return;
  try {
    
  function initializeCherifyReviewTabs(root) {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    if (!tabs.length || root.dataset.tabsReady) return;
    root.dataset.tabsReady = 'true';
    const select = (tab) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        root.querySelector(`#${item.dataset.reviewPanel}`).hidden = !selected;
      });
    };
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tabs.includes(tab)) select(tab);
    });
    root.addEventListener('keydown', (event) => {
      const index = tabs.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      select(tabs[next]);
      tabs[next].focus();
    });
  }
  document.querySelectorAll('.cherify-product-reviews').forEach(initializeCherifyReviewTabs);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.cherify-product-reviews').forEach(initializeCherifyReviewTabs);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-category-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activate = (root, nextTab) => {
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const seeAll = root.querySelector('[data-christmas-see-all]');
      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = root.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !selected;
      });
      if (seeAll && nextTab.dataset.collectionUrl) seeAll.href = nextTab.dataset.collectionUrl;
      nextTab.focus({ preventScroll: true });
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-christmas-tabs]').forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        const tabs = [...root.querySelectorAll('[role="tab"]')];
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(root, tab));
          tab.addEventListener('keydown', (event) => {
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(root, tabs[nextIndex]);
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-gift-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-editorial-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;
        const track = carousel.querySelector('[data-editorial-track]');
        const previous = carousel.querySelector('[data-editorial-prev]');
        const next = carousel.querySelector('[data-editorial-next]');
        const cards = [...carousel.querySelectorAll('[data-editorial-slide]')];
        if (!track || !previous || !next || !cards.length) return;
        carousel.dataset.initialized = 'true';
        let centerIndex = cards.findIndex((card) => /first christmas/i.test(card.textContent));
        if (centerIndex < 0) centerIndex = 0;
        let busy = false;
        let startX = null;
        let startY = null;
        const offsetFor = (index) => {
          let offset = index - centerIndex;
          if (offset > cards.length / 2) offset -= cards.length;
          if (offset < -cards.length / 2) offset += cards.length;
          return offset;
        };
        const render = () => {
          cards.forEach((card, index) => {
            const offset = offsetFor(index);
            card.removeAttribute('data-editorial-pos');
            card.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
            card.tabIndex = offset === 0 ? 0 : -1;
            if (Math.abs(offset) <= 2) card.dataset.editorialPos = String(offset);
          });
          track.dataset.editorialReady = 'true';
        };
        const shift = (direction) => {
          if (!direction || busy || cards.length < 2) return;
          busy = true;
          centerIndex = (centerIndex + direction + cards.length) % cards.length;
          render();
          window.setTimeout(() => { busy = false; }, 610);
        };
        cards.forEach((card, index) => card.addEventListener('click', (event) => { const offset = offsetFor(index); if (offset !== 0) { event.preventDefault(); event.stopPropagation(); shift(offset); } }));
        previous.addEventListener('click', (event) => { event.preventDefault(); shift(-1); });
        next.addEventListener('click', (event) => { event.preventDefault(); shift(1); });
        track.addEventListener('pointerdown', (event) => { startX = event.clientX; startY = event.clientY; });
        track.addEventListener('pointerup', (event) => { if (startX === null || startY === null) return; const dx = event.clientX - startX; const dy = event.clientY - startY; startX = null; startY = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) shift(dx < 0 ? 1 : -1); });
        track.addEventListener('pointercancel', () => { startX = null; startY = null; });
        carousel.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') { event.preventDefault(); shift(-1); } else if (event.key === 'ArrowRight') { event.preventDefault(); shift(1); } });
        render();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCountdown = (root) => {
      root.querySelectorAll('[data-christmas-countdown]').forEach((countdown) => {
        if (countdown.dataset.initialized === 'true') return;
        const target = Date.parse(countdown.dataset.target || '');
        if (!Number.isFinite(target)) {
          countdown.hidden = true;
          return;
        }
        countdown.dataset.initialized = 'true';
        const fields = {
          days: countdown.querySelector('[data-countdown-days]'),
          hours: countdown.querySelector('[data-countdown-hours]'),
          minutes: countdown.querySelector('[data-countdown-minutes]'),
        };
        let intervalId;
        const update = () => {
          const remaining = Math.max(0, target - Date.now());
          const seconds = Math.floor(remaining / 1000);
          fields.days.textContent = String(Math.floor(seconds / 86400)).padStart(2, '0');
          fields.hours.textContent = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
          fields.minutes.textContent = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
          if (remaining === 0) window.clearInterval(intervalId);
        };
        update();
        intervalId = window.setInterval(update, 1000);
      });
    };

    const initSnow = (root) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.querySelectorAll('[data-christmas-snowfall]').forEach((snowfall) => {
        if (snowfall.dataset.initialized === 'true') return;
        snowfall.dataset.initialized = 'true';
        const fragment = document.createDocumentFragment();
        const randomBetween = (min, max) => Math.random() * (max - min) + min;
        const count = window.innerWidth <= 749 ? 40 : 85;
        for (let index = 0; index < count; index += 1) {
          const flake = document.createElement('span');
          flake.className = 'christmas-snowflake';
          flake.style.left = `${randomBetween(0, 100)}vw`;
          flake.style.setProperty('--size', `${randomBetween(1, 4).toFixed(1)}px`);
          flake.style.setProperty('--opacity', randomBetween(0.45, 0.95).toFixed(2));
          flake.style.setProperty('--blur', `${randomBetween(0, 0.7).toFixed(1)}px`);
          flake.style.setProperty('--fall-duration', `${randomBetween(11, 22).toFixed(2)}s`);
          flake.style.setProperty('--sway-duration', `${randomBetween(3, 7).toFixed(2)}s`);
          flake.style.setProperty('--delay', `${randomBetween(-22, 0).toFixed(2)}s`);
          flake.style.setProperty('--sway-delay', `${randomBetween(-7, 0).toFixed(2)}s`);
          flake.style.setProperty('--drift', `${randomBetween(-45, 45).toFixed(0)}px`);
          flake.style.setProperty('--rotation', `${randomBetween(-120, 120).toFixed(0)}deg`);
          fragment.appendChild(flake);
        }
        snowfall.appendChild(fragment);
      });
    };

    const init = (root = document) => {
      initCountdown(root);
      initSnow(root);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.feature-grid-scroll-wrapper.carousel').forEach((wrapper) => {
      const section = wrapper.closest('.feature-grid-section2');
      const items = wrapper.querySelectorAll('.feature-grid-item');
      const dots = section?.querySelectorAll('.feature-grid-scroll-indicators .dot');

      if (!items.length || !dots?.length) return;

      let currentIndex = 0;

      const showSlide = (index) => {
        items.forEach((item, i) => {
          item.classList.toggle('active', i === index);
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
      };

      showSlide(currentIndex);

      let startX = 0;

      wrapper.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
      });

      wrapper.addEventListener('touchend', (event) => {
        const endX = event.changedTouches[0].clientX;
        if (startX - endX > 50) {
          currentIndex = Math.min(currentIndex + 1, items.length - 1);
          showSlide(currentIndex);
        } else if (endX - startX > 50) {
          currentIndex = Math.max(currentIndex - 1, 0);
          showSlide(currentIndex);
        }
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          currentIndex = index;
          showSlide(currentIndex);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tabbed-collections]').forEach(function (section) {  // section = .tabbed-collections inner div
      var tabs = section.querySelectorAll('.tabbed-collections__tab');
      var grid = section.querySelector('[data-grid]');
      var exploreBtn = section.querySelector('[data-explore-btn]');
      var cache = {};

      function setActiveTab(activeTab) {
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === activeTab);
          t.setAttribute('aria-selected', t === activeTab ? 'true' : 'false');
        });
        if (exploreBtn && activeTab.dataset.tabLink) {
          exploreBtn.href = activeTab.dataset.tabLink;
        }
      }

      function loadTab(tab) {
        var handle = tab.dataset.collection;
        if (!handle) return;

        if (cache[handle]) {
          grid.innerHTML = cache[handle];
          setActiveTab(tab);
          return;
        }

        tab.setAttribute('aria-busy', 'true');
        fetch('/collections/' + handle + '?sections=tabbed-collections')
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var html = json['tabbed-collections'];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-grid]');
            if (newGrid) {
              cache[handle] = newGrid.innerHTML;
              grid.innerHTML = cache[handle];
            }
            setActiveTab(tab);
          })
          .catch(function () { setActiveTab(tab); })
          .finally(function () { tab.removeAttribute('aria-busy'); });
      }

      if (tabs[0]) {
        var firstHandle = tabs[0].dataset.collection;
        if (firstHandle) cache[firstHandle] = grid.innerHTML;
        setActiveTab(tabs[0]);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (tab.classList.contains('is-active')) return;
          if (!tab.dataset.collection) return;
          loadTab(tab);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
